<template>
  <el-dropdown @command="onStatus" size="normal" class="avaya-status" :disabled="isReconnect">
    <div>
      <!-- 客服状态 -->
      {{ $t('crm.onlineCs.status.customer') }}：
      <!-- <template v-if="isReconnect">
        <i class="el-icon-loading"></i>
        <span class="v-f-14">重连中({{ currentStatusOption.label }})</span>
        <el-tooltip effect="light">
          <template #content>
            <div class="v-f-12" style="line-height: 24px">
              <div>avaya断线重连中，请稍后...</div>
              <div>此时进行呼叫相关操作可能会失败，请在one-x上完成操作</div>
              <div>
                若长时间未重连成功，请
                <a href="https://itss.amh-group.com/amhNet.html" target="_blank" class="text-link">点击此处</a>
                进行网络自助诊断，并在等待10s后截图反馈问题。
              </div>
              <div>或刷新页面重新切换在线</div>
            </div>
          </template>
          <i class="el-icon-question v-ml-5"></i>
        </el-tooltip>
      </template>
      <template v-else> -->
      <img :src="currentStatusOption.icon" style="width: 16px; height: 16px;transform:translateY(3px)" />
      <span class="v-pl-5 v-f-14 v-hoverable">{{ $t(currentStatusOption.langCode) }}</span>
      <!-- </template> -->
    </div>
    <el-dropdown-menu slot="dropdown" trigger="click">
      <el-dropdown-item v-for="item in statusList" :key="item.value" :command="item.value">
        <div class="v-flex-middle v-relative">
          <img
            :src="checkIcon"
            style="width: 9px; height: 7px; position: absolute; left: 2px"
            v-if="currentStatus === item.value"
          />
          <img :src="item.icon" style="width: 12px; height: 12px" />
          <span class="v-pl-5 v-f-14 v-hoverable">{{ $t(item.langCode) }}</span>
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import checkIcon from '@/assets/images/status/check.png'
import { querySeatState } from './serve'
import { notifyMe } from '@/util/systemNotice.js'
/**
 * @description 客服状态
 * 电话客服 在线客服 两种不同的状态列表
 * 电话客服状态切换：
 * IM状态切换：IM页面
 */
export default {
  name: 'ToggleStatus',
  props: {
    statusList: {
      type: Array,
      required: true
    },
    currentStatus: {
      type: Number,
      required: true
    },
    isReconnect: {
      type: Boolean,
      default: false
    },
    isRegionCallIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkIcon,
      manualOffline: false
    }
  },
  watch: {
    currentStatus: {
      handler: function(val) {
        if (this.isRegionCallIn) {
          console.log('watch currentStatus', val)
          this.clearTimer()
          this.timer = setInterval(async () => {
            try {
              const data = await querySeatState()
              // 如果接口返回的离线，并且不是手动切的离线时
              if (data.loginStatus !== 1 && !this.manualOffline) {
                if (document.visibilityState !== 'visible') {
                  notifyMe({
                    title: '离线通知',
                    message: 'avaya异常掉线，请处理'
                  })
                } else if (window.localStorage.getItem('_crm_avaya_system_notify') === '1') {
                  // 开关开了就提示
                  this.$message.error('avaya异常掉线，请处理')
                }
              }
            } catch (error) {
              console.error('error', error)
            }
          }, 2 * 60 * 1000) // 每2分钟调取一次查询结果
        }
      },
      immediate: true
    }
  },
  computed: {
    currentStatusOption() {
      return this.statusList.find(item => item.value === this.currentStatus) || {}
    }
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    /** 切换状态*/
    onStatus(val) {
      console.log('手动切换状态', val)
      this.$emit('change', val)
      if (val === 2) {
        this.manualOffline = true // 表示手动切的下线，这个时候可以不必通知用户
      }
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-dropdown
  color #424f6b
</style>
